// extracted by mini-css-extract-plugin
export default {"AddToCart":"addToCartButton-module--AddToCart--3049b"};